/**
 * Runtime configuration loaded from /config.json at boot.
 * The file is served from /public and can be overridden per-environment
 * without rebuilding the bundle.
 */

export type AuthMode = 'fake' | 'cognito';

export interface RuntimeConfig {
  API_BASE_URL: string;
  COGNITO_DOMAIN: string;
  COGNITO_USER_POOL_ID: string;
  COGNITO_CLIENT_ID: string;
  COGNITO_ISSUER_URL: string;
  REGION: string;
  AUTH_MODE: AuthMode;
}

let cached: RuntimeConfig | null = null;

export async function loadConfig(): Promise<RuntimeConfig> {
  if (cached) return cached;
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) {
    throw new Error(`Failed to load /config.json: ${res.status}`);
  }
  const raw = (await res.json()) as Partial<RuntimeConfig>;
  cached = {
    API_BASE_URL: raw.API_BASE_URL ?? '',
    COGNITO_DOMAIN: raw.COGNITO_DOMAIN ?? '',
    COGNITO_USER_POOL_ID: raw.COGNITO_USER_POOL_ID ?? '',
    COGNITO_CLIENT_ID: raw.COGNITO_CLIENT_ID ?? '',
    COGNITO_ISSUER_URL: raw.COGNITO_ISSUER_URL ?? '',
    REGION: raw.REGION ?? '',
    AUTH_MODE: (raw.AUTH_MODE as AuthMode) ?? 'fake',
  };
  return cached;
}

export function getConfig(): RuntimeConfig {
  if (!cached) {
    throw new Error('Runtime config not loaded yet — call loadConfig() in main.tsx first.');
  }
  return cached;
}
